import { useQuery } from "@tanstack/react-query";
import useApi from "../../../../../shared/hooks/useApi";
import type { CaregiverProfileCaregiver } from "../../../caregiverProfileModal.types";

export function useCaregiverVisitEngagements(caregiverId: CaregiverProfileCaregiver["id"]) {
  const { api } = useApi();

  return useQuery({
    queryKey: ["caregiverProfileModal", caregiverId, "visitEngagements"],
    queryFn: () =>
      api.get("/agencies/:agencyId/caregivers/:caregiverId/visit_engagements", {
        path: { caregiverId },
      }),
  });
}
